import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../img/logo.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMobileNav = () => setIsMobileNavOpen(false);

  return (
    <header
      id="header"
      className={`fixed-top ${isScrolled ? "header-scrolled" : ""}`}
    >
      <div className="container d-flex align-items-center flex-wrap">
        <Link to="/" className="logo me-auto" onClick={closeMobileNav}>
          <img src={Logo} alt="IT Assist Experts" className="img-fluid" />
        </Link>

        <nav
          id="navbar"
          className={`navbar ${isMobileNavOpen ? "navbar-mobile" : ""}`}
        >
          <ul>
            <li>
              <Link className="nav-link" to="/" onClick={closeMobileNav}>
                Home
              </Link>
            </li>
            <li>
              <Link className="nav-link" to="/printer" onClick={closeMobileNav}>
                IT Services
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="/data-recovery"
                onClick={closeMobileNav}
              >
                Data Recovery
              </Link>
            </li>
            <li>
              <Link className="nav-link" to="/aboutus" onClick={closeMobileNav}>
                About
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="/contactus"
                onClick={closeMobileNav}
              >
                Contact
              </Link>
            </li>
          </ul>
          <button
            type="button"
            className={`bi ${
              isMobileNavOpen ? "bi-x" : "bi-list"
            } mobile-nav-toggle`}
            onClick={() => setIsMobileNavOpen((isOpen) => !isOpen)}
            aria-label="Toggle navigation"
          ></button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
